import { Controller } from "@hotwired/stimulus"

// Builder controller for the interactive command builder
// Server-rendered commands are updated via form submission (Turbo)
// This controller only handles clipboard functionality
export default class extends Controller {
  static targets = ["cliOutput", "pythonOutput", "cliCopyBtn", "pythonCopyBtn"]

  connect() {
    // Commands are rendered server-side, no client-side update needed
    this.updateCopyButtons()
  }

  updateCopyButtons() {
    // Update copy button data attributes with the server-rendered content
    const cliElement = document.getElementById("cli-command")
    const pythonElement = document.getElementById("python-snippet")
    
    if (this.hasCliCopyBtnTarget && cliElement) {
      this.cliCopyBtnTarget.dataset.clipboardText = cliElement.textContent
    }
    if (this.hasPythonCopyBtnTarget && pythonElement) {
      this.pythonCopyBtnTarget.dataset.clipboardText = pythonElement.textContent
    }
  }
}
